import { OrderExecutionModel } from "app/bfx-execution-monitor/models/OrderExecutionModel";

export enum ExecutionMonitoringCmd {
  UPDATE_MODEL,
  CLEAR_MODEL,
  ACTION_RESPONSE,
  LOST_VISIBILITY,
}

export class ExecutionMonitoringCmdPayload {
  constructor(
    public command: ExecutionMonitoringCmd,
    public orderId: string,
    public payload?: OrderExecutionModel,
  ) {}
}
